export const NAMESPACE = 'flatManual';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
